module.exports = __webpack_public_path__ + "img/chinesecompany70.5e1dc7aa.png";